import axios from "axios";
import { ElMessage } from "element-plus"; 
import router from "@/router";
const request = axios.create({
    baseURL: 'https://jjw-ai.asia/api',
    // baseURL:'http://localhost:9999',
    timeout:30000
})


request.interceptors.request.use(config => {
    config.headers['Content-Type'] = 'application/json;charset=utf-8';
    let user = JSON.parse(localStorage.getItem('code_user') || '{}')
    config.headers['token'] = user.token
    console.log("token",config.headers['token'])
    return config
},error => {
    return Promise.reject(error)


});

request.interceptors.response.use(
    response => {
        let res = response.data;
        if(typeof res === 'string'){
            res = res ? JSON.parse(res) : res
        }
         // UserData01 是免登录页面：即使接口返回401也不跳登录，保证直接显示页面
        const isUserData01Page = router.currentRoute.value.path === '/UserData01';
        if(res.code === '401' && !isUserData01Page){
            ElMessage.error(res.msg)
            router.push('/login')
        }else {
            return res;
        }
        
    },
    error => {
        if(error.response.status === 404){
            ElMessage.error('未找到请求接口')
        }else if (error.response.status === 500){
            ElMessage.error('系统异常,请查看后台控制台报错')
        } else {
            console.error(error.message)
        }
        return Promise.reject(error)
    }
)
export default request